module.exports = __webpack_public_path__ + "img/lead-8z.5a4ccd1c.png";